let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iW7i1")).then(() => parcelRequire('dlbJ7'));